import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@sara/ui/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        success:
          'border-transparent bg-success-muted text-success ring-1 ring-inset ring-success/25 hover:bg-success-muted/80',
        warning:
          'border-transparent bg-warning-muted text-warning ring-1 ring-inset ring-warning/25 hover:bg-warning-muted/80',
        info: 'border-transparent bg-info-muted text-info ring-1 ring-inset ring-info/25 hover:bg-info-muted/80',
        danger:
          'border-transparent bg-destructive/10 text-destructive ring-1 ring-inset ring-destructive/25 hover:bg-destructive/15',
        neutral:
          'border-transparent bg-muted text-muted-foreground ring-1 ring-inset ring-border hover:bg-muted/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
